<template>
  <BaseCard>
    <BaseCardBody v-if="errorMessage">
      <div>
        {{ this.errorMessage }}
      </div>
    </BaseCardBody>
    <BaseCardBody v-else-if="showAgencyPicker">
      <div class="flex space-x-4">
        <BaseFormSelect v-model="formData.accountId" :disabled="loading" :options="agencyOptions" />
        <BaseFormSelect
          v-if="selectedAgency"
          v-model="formData.accountRelationId"
          :disabled="loading"
          :options="clientOptions"
        />
        <BaseButton
          v-if="formData.accountId && formData.accountRelationId"
          primary
          type="button"
          :disabled="loading"
          @click="transferOffer"
        >
          Transfer Offer
        </BaseButton>
      </div>
    </BaseCardBody>
    <BaseCardBody v-else>
      <BaseButton type="button" primary :disabled="loading" @click="setShowAgencyPicker(true)">
        Transfer Offer
      </BaseButton>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import { getAccountListApi } from '@/api/clients';

export default {
  props: {
    offerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      showAgencyPicker: false,
      formData: {
        accountId: null,
        accountRelationId: null,
      },
      agencies: [],
    };
  },
  computed: {
    offer() {
      return this.$store.state.entities.offers.byId[this.offerId];
    },
    agencyOptions() {
      return this.agencies.map((agency) => ({
        label: agency.name,
        value: agency.id,
      }));
    },
    selectedAgency() {
      return this.agencies.find((agency) => agency.id === this.formData.accountId) || null;
    },
    clientOptions() {
      if (!this.selectedAgency) return [];

      return this.selectedAgency.clients.map((client) => ({
        label: client.name,
        value: client.accountRelationId,
      }));
    },
  },
  watch: {
    'formData.accountId': {
      handler(accountId, oldAgencyId) {
        if (accountId !== oldAgencyId) {
          this.formData.accountRelationId = null;
        }
      },
    },
  },
  created() {
    this.fetchAgencies();
  },
  methods: {
    setLoading(loading) {
      this.loading = Boolean(loading);
    },
    setErrorMessage(message) {
      this.errorMessage = message;
    },
    setShowAgencyPicker(showAgencyPicker) {
      this.showAgencyPicker = Boolean(showAgencyPicker);
    },
    async fetchAgencies() {
      try {
        this.setLoading(true);
        const response = await getAccountListApi({
          filter: {
            type: 'organization',
          },
          include: 'clients',
        });

        this.agencies = response.data.data;
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
    async transferOffer() {
      try {
        this.setLoading(true);
        await this.$store.dispatch({
          type: 'ui/offers/transfer',
          offerId: this.offerId,
          formData: this.formData,
        });

        this.$emit('offer-transferred');
      } catch (error) {
        this.setErrorMessage('Something went wrong!');
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
